var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "88.281%",
    y1: "100%",
    x2: "11.719%",
    y2: "0%",
    id: "Import_svg__[object_Object]c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B8B99",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BADBC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-.4%",
    y: "-3.6%",
    width: "100.9%",
    height: "109.3%",
    filterUnits: "objectBoundingBox",
    id: "Import_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0534309441 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Import_svg__[object_Object]b",
    x: 0,
    y: 0,
    width: 1004,
    height: 97,
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -65)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#Import_svg__[object_Object]a)",
    xlinkHref: "#Import_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#E1E9F0",
    fill: "#FFF",
    x: -0.5,
    y: -0.5,
    width: 1005,
    height: 98,
    rx: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h10zm-6.389 9H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5H5.61a.5.5 0 00.5-.5v-.62a.5.5 0 00-.5-.5zm2.667-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h5.222a.5.5 0 00.5-.5V8.8a.5.5 0 00-.5-.5zm2.666-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h7.888a.5.5 0 00.5-.5V6.1a.5.5 0 00-.5-.5z",
    transform: "translate(0 -2)",
    fill: "url(#Import_svg__[object_Object]c)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;